var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 11.1303C9.32265 11.1303 9.6452 11.0071 9.89115 10.7613L17.6307 3.02158C18.1231 2.52924 18.1231 1.731 17.6307 1.23886C17.1386 0.746716 16.3405 0.746716 15.8481 1.23886L9.00005 8.08735L2.15192 1.2391C1.65958 0.746955 0.861574 0.746955 0.369474 1.2391C-0.123104 1.73124 -0.123104 2.52948 0.369474 3.02182L8.10895 10.7615C8.35502 11.0074 8.67757 11.1303 9.00005 11.1303Z",
    fill: "#328734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowDown);
export default __webpack_public_path__ + "static/media/green_arrow_down.5a56d69ab5ff5f044b06704a7f321e88.svg";
export { ForwardRef as ReactComponent };